import { Icon } from 'corso-admin-ui';
import { match, P } from 'ts-pattern';

export default function CarrierIcon({ carrierName }: { carrierName: string }) {
  const icon = match(carrierName.toLowerCase())
    .with(P.string.includes('fedex'), () => 'fedex' as const)
    .with(P.string.includes('usps'), () => 'usps' as const)
    .with(P.string.includes('ups'), () => 'ups' as const)
    .with(P.string.includes('dhl'), () => 'dhl' as const)
    .otherwise(() => 'shipment' as const);

  return <Icon icon={icon} className="h-8 w-8" />;
}
